import { Component, Vue } from "vue-property-decorator";
import graphContent from "@/components/graphContent/graphContent.vue";
import VueStore from "@/store/VueStore";
import { confirmAddGraph, makeIds } from "./scripts/add_graph";
import { confirmDeleteGraph } from "./scripts/delete_graph";
import { MstGraphType } from "@/types/types";
import CognitoController from "@/common/scripts/cognito_controller";
import router from "@/router";
import { i18n } from "@/main";
import MstGraphService from "@/services/mst_graph_service";
import GetRegionList from "@/components/graphContent/scripts/get_regions";
import axios from "axios";
import { RequestParamsMaker } from "@/components/graphContent/scripts/make_request_params";
import VueRouter from "vue-router";
import { ElMessageComponent } from "element-ui/types/message";

const draggable = require("vuedraggable");

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "index",
  components: {
    graphContent,
    draggable
  }
})
export default class IndexContent extends Vue {
  public graphTypes: string[] = JSON.parse(
    localStorage.getItem("graphSettings")
  ).graphTypes;
  public graphIDs: number[] = JSON.parse(localStorage.getItem("graphSettings"))
    .graphIDs;
  public token: string = VueStore.state.token;
  public draggable: boolean = true;
  public options: any = {
    animation: 200,
    draggable: ".el-col",
    handle: ".drag-area",
    disabled: this.draggable,
    group: "graph",
    scrollSensitivity: 200,
    scrollSpeed: 30
  };
  public changeGraphWidthSizeFlug: boolean = false;
  public regionsList: string[] = [];
  public noticeMessage: ElMessageComponent;

  public async created() {
    if (VueStore.state.token === null) {
      return router.push("/signIn");
    }
    this.$parent.$children[0].$data.headerElement = true;
    this.regionsList = await GetRegionList.getRegions();
    await this.openNotice();
  }
  public beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    if (this.noticeMessage) {
      this.noticeMessage.$data.closed = true;
    }
    next();
  }
  // お知らせを表示
  public async openNotice() {
    const userName = VueStore.state.userName;
    const requestParams = RequestParamsMaker.makePostNoticeDataParams(userName);
    const apiResponse = await axios(requestParams);
    const res = apiResponse.data.res;
    if (!apiResponse.data.res) {
      return;
    }
    // テーブルにurlがあるか見てクリップの表示を変える
    if (res.notice_message && res.notice_url) {
      this.noticeMessage = this.$message({
        dangerouslyUseHTMLString: true,
        message:
          "<p>" +
          res.notice_message +
          "<a href=" +
          res.notice_url +
          " target='_blank'><i class='el-icon-paperclip'></i></a>" +
          "</p>",
        duration: 0,
        offset: 60,
        showClose: true,
        async onClose() {
          const closeRequestParams = RequestParamsMaker.makePutUserNameParams(
            userName,
            res.timestamp
          );
          await axios(closeRequestParams);
        }
      });
    }
    if (res.notice_message && !res.notice_url) {
      this.noticeMessage = this.$message({
        dangerouslyUseHTMLString: true,
        message: "<p>" + res.notice_message + "</p>",
        duration: 0,
        offset: 60,
        showClose: true,
        async onClose() {
          const closeRequestParams = RequestParamsMaker.makePutUserNameParams(
            userName,
            res.timestamp
          );
          await axios(closeRequestParams);
        }
      });
    }
  }
  /**
   * 並び替えモードに切り替え
   */
  public changeSortMode() {
    this.options.disabled = !this.draggable;
    const graphContentComponents = this.$children[3].$children;
    graphContentComponents.forEach((component: any) => {
      component.$children[0].$data.canvasArea = !component.$children[0].$data
        .canvasArea;
    });
  }

  /**
   * 切り替えモードの終了
   */
  public finishSortMode() {
    this.options.disabled = false;
    const graphContentComponents = this.$children[3].$children;
    graphContentComponents.forEach((component: any) => {
      component.$children[0].$data.canvasArea = true;
    });
  }

  /**
   * 並び替えた状態を保存
   */
  public async updateGraphIDs() {
    const cognitoController = new CognitoController();
    const newGraphIDs: number[] = this.graphIDs;
    cognitoController.setGraphIDs(newGraphIDs);
    await cognitoController.update();
  }

  /**
   * グラフComponent追加
   */
  public async addGraph() {
    try {
      await confirmAddGraph(this);
      // this.selectType = false;
    } catch (err) {
      alert(this.$t("message.failedToAddGraph"));
      console.error(err);
    }
  }

  /**
   * グラフComponent削除
   * @param graphID
   * @param title
   */
  public async deleteGraph(graphID: number, title: string, userID: string) {
    let deleteCheckMessage: string = "";
    // 変数入りのメッセージが文法上おかしくないようif分岐
    if (i18n.locale === "ja") {
      deleteCheckMessage =
        `\"${title}\"` +
        this.$t("message.areYouSureYouWantToDeleteGraph") +
        this.$t("message.allSettingsAndAlarmHistoryWillAlsoBeDeleted");
    } else {
      deleteCheckMessage =
        this.$t("message.areYouSureYouWantToDeleteGraph") +
        `\"${title}\"` +
        this.$t("message.questionMark") +
        this.$t("message.allSettingsAndAlarmHistoryWillAlsoBeDeleted");
    }
    const deleteCheck = confirm(deleteCheckMessage);
    if (deleteCheck) {
      try {
        await confirmDeleteGraph(graphID, this.$data, userID);
        // router.push("/signIn");
      } catch (err) {
        alert(this.$t("message.failedToDeleteGraph"));
        console.error(err);
      }
    }
  }

  /**
   * グラフ設定のコピー
   * @param mstGraph
   */
  public async copySetting(mstGraph: MstGraphType) {
    try {
      const self = this;
      const graphIDs: number[] = makeIds(self);
      mstGraph.graph_id = graphIDs[graphIDs.length - 1];
      const copyMstGraph = JSON.parse(JSON.stringify(mstGraph));
      // changeAlertSwitchとthresholdSettingsListは後から属性追加したため、
      // 存在しない場合はデフォルト値で置き換える
      if (copyMstGraph.changeAlertSwitch === null) {
        copyMstGraph.changeAlertSwitch = false;
      }
      if (copyMstGraph.thresholdSettingsList === null) {
        copyMstGraph.thresholdSettingsList = [];
      }
      await MstGraphService.create(copyMstGraph);
      await this.addGraph();
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * グラフ横サイズの変更
   * false 横2つ表示 default
   * true 横1つ表示
   */
  public changeGraphWidthSize() {
    this.changeGraphWidthSizeFlug = !this.changeGraphWidthSizeFlug;
  }
}
